export default __webpack_public_path__ + "static/media/F.64eb966c.svg";